import styled from 'styled-components';

export const ReportContainerStyled = styled.div`

`;
